import compact from 'lodash/compact';
import castArray from 'lodash/castArray';

import {
    DictionaryListParams,
    Dictionaries,
    DictionaryResponse,
    DictionaryListResponse,
    DictionaryFindOption,
    UpdateDictionaryItemParams,
    CreateDictionaryItemParams,
} from 'chaika-frontend-types/frontend-cms';
import { DictionaryItemStatus, DictionaryNames } from 'chaika-enums';

import { axios } from '@lib/axios';

const DICTIONARY_URL = '/api';

export class DictionaryApi {
    public static async getDictionariesNames(): Promise<DictionaryListParams[]> {
        const res = await axios.get<DictionaryListResponse>(`${DICTIONARY_URL}/dictionary`);

        return res.data.dictionaries;
    }

    public static async getByNames(
        dictionaryNames: (DictionaryNames | string)[],
        params: Pick<DictionaryFindOption, 'limit' | 'offset' | 'locale' | 'withTranslations' | 'withTies'> = {},
    ): Promise<Dictionaries> {
        const names = dictionaryNames.join(',');

        const res = await axios.get<DictionaryResponse>(`${DICTIONARY_URL}/dictionary-item`, {
            params: { names, ...params },
        });

        return res.data.items;
    }

    public static async find({
        ids,
        title,
        parentId,
        childId,
        ...params
    }: DictionaryFindOption): Promise<Dictionaries> {
        const compactIds = !!ids ? (Array.isArray(ids) ? compact(ids) : [ids]) : undefined;
        const res = await axios.get<DictionaryResponse>(`${DICTIONARY_URL}/dictionary-item`, {
            params: {
                ...params,
                title: !!title ? title.trim() : undefined,
                ids: compactIds ? compactIds.join(',') : undefined,
                parentId: castArray(parentId).join(',') || undefined,
                childId: castArray(childId).join(',') || undefined,
            },
        });

        return res.data.items;
    }

    public static async createDictionaryItem(item: CreateDictionaryItemParams): Promise<void> {
        await axios.post(`${DICTIONARY_URL}/dictionary-item`, { item });
    }

    public static async updateDictionaryItem(id: string, item: Partial<UpdateDictionaryItemParams>): Promise<void> {
        await axios.put(`${DICTIONARY_URL}/dictionary-item/${id}`, { item });
    }

    public static async removeDictionaryItem(id: string): Promise<void> {
        await axios.delete(`${DICTIONARY_URL}/dictionary-item/${id}`);
    }

    public static async updateDictionaryItemStatus(id: string, status: DictionaryItemStatus): Promise<void> {
        await axios.put(`${DICTIONARY_URL}/dictionary-item/${id}/status`, { status });
    }
}
